
<template>
    <div class="sb_make_doc">
        <div class="row">
            <div class="col-lg-9">
                <div class="panel mobile_agronom">
                    <make_doc_title title="Додати моібльний щоденик"></make_doc_title>
                    
                    <div class="panel-container show">
                        <div class="panel-content">
                            
                            <div class="template p-3">
                                <organization_select
                                    @on_organization_set="set_org_id"
                                    :active_id="parseInt(form.org_id)">
                                </organization_select>
                            </div>
                            
                            <div class="template p-3">
                                <div class="form-group">
                                    <label class="form-label" for="payment_online">
                                        Виберiть з випадаючого списку стан*
                                    </label>
                                    <div>
                                        <b-form-radio-group
                                            id="btn-radios-1"
                                            v-model="form.rating"
                                            button-variant="outline-primary"
                                            :options="rating_variants"
                                            name="radios-btn-default"
                                            buttons
                                        ></b-form-radio-group>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="template p-3">
                                <label class="form-label" for="payment_online">
                                    Введiть коментар
                                </label>
                                
                                <div class="select_step">
                                    <b-textarea v-model="form.comment" :rows="5"></b-textarea>
                                </div>
                            </div>
                            
                            <button class="btn btn-lg btn-outline-primary waves-effect waves-themed mt-5"
                                    :class="can_save ? 'btn-outline-success' : 'btn-outline-danger'"
                                    v-on:click="save_doc" :disabled=!can_save>
                                <span class="fal" :class="{'fa-check mr-1' : can_save, 'fa-exclamation-triangle' : !can_save}"></span>
                                Зберегти
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="col-lg-3">
                <div class="panel  ">
                    <make_doc_title title="Файли"></make_doc_title>
                    <div class="panel-container show">
                        <div class="panel-content">
                            <fileloader
                                :validate_geo="true"
                                :can_del="true"
                                key="file_loader_mem"
                                doc_type="mobile_sb"
                                v-bind:trigger_load="load_trigger"
                            >
                            </fileloader>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Make_doc_title from "../../../shared/helpers/make_doc_title.vue";
import Organization_select from "../../../shared/select/organization_select.vue";
import fileloader from "../../../shared/file_loader/fileloader.vue";

export default {
    name: "doc_create",
    components: {fileloader, Organization_select, Make_doc_title},
    data() {
        return {
            load_trigger:  "loader_load_file",
            form : {
                "org_id" : 0,
                "rating" : 0,
                "comment" : "",
                "files" : [],
            }
        }
    },
    
    created() {
        EventBus.$on(this.load_trigger,this.work_files)
    },
    
    methods : {
        
        set_org_id(org_id) {
            if(parseInt(org_id) > 0) {
                this.form.org_id = parseInt(org_id);
            }
            else {
                this.form.org_id = 0;
            }
        },
        
        work_files(event) {
            if (event != undefined) {
                if(event.hasOwnProperty('type')) {
                    if (event.type === 'file_loaded') {
                        this.form.files.push(event);
                    }
                    
                    if (event.type === 'file_deleted') {
                        for (let i = this.form.files.length - 1; i >= 0; i -= 1) {
                            if (parseInt(this.form.files[i].file_id) === parseInt(event.file_id)) {
                                this.form.files.splice(i, 1);
                            }
                        }
                    }
                }
            }
        },
        
        async save_doc() {
            IMC_CORE.showloading();
            await api.put('/sb/doc',this.form).then(({data}) => {
                IMC_CORE.hideloading();
                window.location.reload();
            }).catch(err => {
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});
                IMC_CORE.hideloading();
            });
        }
    },
    
    computed : {
        rating_variants() {
            return [
                { text: 'Добрий', value: 1 },
                { text: 'Задов.', value: 2 },
                { text: 'Незадов.', value: 3 },
            ]
        },
        
        can_save() {
            if (!parseInt(this.form.org_id) > 0) {
                return false;
            }
            
            if (!parseInt(this.form.rating) > 0) {
                return false;
            }
            
            if(!this.form.files.length > 0) {
                return false;
            }
            
            return true;
        },
    }
}
</script>


<style scoped>

</style>